import { useState } from "react";
import GameShell from "../GameShell";

/**
 * Portal dos Guardiões — ADI-R / CARS inspired.
 * Questionnaire for the responsible adult. 12 items, scale Nunca/Às vezes/Sempre.
 * Some items count for "social_communication", others for "restricted_repetitive" (CARS-like).
 */
export default function GuardianPortal() {
  return (
    <GameShell gameId="guardian_portal" title="Portal dos Guardiões">
      {({ onFinish }) => <Game onFinish={onFinish} />}
    </GameShell>
  );
}

const SCALE = [
  { v: 0, label: "Nunca" },
  { v: 1, label: "Às vezes" },
  { v: 2, label: "Frequentemente" },
  { v: 3, label: "Sempre" },
];

const ITEMS = [
  { text: "Responde quando alguém chama o nome dele(a).", dim: "social", invert: true },
  { text: "Olha nos olhos durante conversa.", dim: "social", invert: true },
  { text: "Compartilha brinquedos espontaneamente.", dim: "social", invert: true },
  { text: "Brinca de faz-de-conta com outras crianças.", dim: "social", invert: true },
  { text: "Aponta para mostrar interesse em algo.", dim: "social", invert: true },
  { text: "Repete movimentos do corpo (balançar, bater mãos).", dim: "repetitive" },
  { text: "Insiste em rotinas e fica desconfortável com mudanças.", dim: "repetitive" },
  { text: "Tem interesses muito específicos e intensos.", dim: "repetitive" },
  { text: "Reage muito a sons, luzes ou texturas.", dim: "repetitive" },
  { text: "Usa frases ou palavras repetidamente fora de contexto.", dim: "repetitive" },
  { text: "Demonstra preocupação quando outra pessoa está triste.", dim: "social", invert: true },
  { text: "Inicia interação social espontaneamente.", dim: "social", invert: true },
];

function Game({ onFinish }) {
  const [idx, setIdx] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [started] = useState(() => performance.now());

  const choose = (v) => {
    const item = ITEMS[idx];
    // If "invert" then higher value of normal answer = healthier; we transform so that higher means more atypical
    const score = item.invert ? 3 - v : v;
    const next = [...answers, { dim: item.dim, raw: v, weighted: score }];
    setAnswers(next);
    if (idx + 1 >= ITEMS.length) {
      const elapsed = performance.now() - started;
      const social = next.filter((a) => a.dim === "social").reduce((s, a) => s + a.weighted, 0);
      const repetitive = next
        .filter((a) => a.dim === "repetitive")
        .reduce((s, a) => s + a.weighted, 0);
      const total = social + repetitive;
      const maxTotal = ITEMS.length * 3;
      onFinish({
        score: 70,
        duration_ms: Math.round(elapsed),
        metrics: {
          items: ITEMS.length,
          social_communication_score: social,
          restricted_repetitive_score: repetitive,
          total_score: total,
          max_total: maxTotal,
          percentage: Number(((total / maxTotal) * 100).toFixed(1)),
        },
      });
    } else {
      setIdx(idx + 1);
    }
  };

  const it = ITEMS[idx];

  return (
    <div className="mt-4 max-w-2xl mx-auto" data-testid="guardian-area">
      <div className="text-center text-white drop-shadow mb-4">
        <div className="text-sm">📋 Questionário para o responsável.</div>
        <div className="text-xs mt-1 opacity-80">Item {idx + 1} / {ITEMS.length}</div>
      </div>
      <div className="kid-card pop-in" key={idx}>
        <div className="text-center text-5xl mb-3">🛡️</div>
        <div className="text-lg text-slate-800 font-bold text-center leading-snug mb-6">
          {it.text}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          {SCALE.map((s) => (
            <button
              key={s.v}
              onClick={() => choose(s.v)}
              className="bg-sky-50 hover:bg-sky-100 active:scale-95 transition rounded-2xl py-3 px-2 font-semibold text-slate-700 border-2 border-transparent hover:border-sky-300"
              data-testid={`guardian-val-${s.v}`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
